/**
 * Engraving Cart Display
 * Renders engravings in cart items using the display component
 */

if (typeof window.EngravingCartDisplay === 'undefined') {
window.EngravingCartDisplay = class EngravingCartDisplay {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.renderAll());
    } else {
      this.renderAll();
    }

    // Re-render on cart updates
    document.addEventListener('cart:updated', () => this.renderAll());
  }

  /**
   * Render all engraving displays
   */
  renderAll() {
    const containers = document.querySelectorAll('.cart-item__engravings-container');
    containers.forEach(container => {
      this.renderEngravings(container);
    });
  }

  /**
   * Render engravings for a container
   * @param {HTMLElement} container - Container element
   */
  async renderEngravings(container) {
    try {
      const jsonString = container.dataset.engravingsJson;
      if (!jsonString) return;

      const engravings = JSON.parse(jsonString);
      if (!Array.isArray(engravings) || engravings.length === 0) {
        container.remove();
        return;
      }

      // Get engraving product info
      const engravingProduct = await this.getEngravingProductInfo();
      if (!engravingProduct) {
        console.warn('Engraving product not available');
        return;
      }

      // Create display HTML
      const html = this.createDisplayHTML(engravings, engravingProduct);
      container.innerHTML = html;
    } catch (error) {
      console.error('Failed to render engravings:', error);
      container.innerHTML = '<p class="engraving-error">Error displaying engravings</p>';
    }
  }

  /**
   * Get engraving product info
   * @returns {Promise<Object>} Engraving product info
   */
  async getEngravingProductInfo() {
    try {
      const response = await fetch('/?section_id=engraving-service-config');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const configScript = doc.querySelector('#engraving-service-config');
      
      if (configScript) {
        return JSON.parse(configScript.textContent);
      }
      return null;
    } catch (error) {
      console.error('Failed to get engraving product info:', error);
      return null;
    }
  }

  /**
   * Create display HTML
   * @param {Array} engravings - Array of engraving objects
   * @param {Object} engravingProduct - Engraving product info
   * @returns {string} HTML string
   */
  createDisplayHTML(engravings, engravingProduct) {
    const engravingList = engravings.map(engraving => {
      const side = engraving.side.charAt(0).toUpperCase() + engraving.side.slice(1);
      return `
        <li class="engraving-item">
          <span class="engraving-location">
            Blade ${engraving.blade} ${side}:
          </span>
          <span class="engraving-text">"${this.escapeHtml(engraving.text)}"</span>
        </li>
      `;
    }).join('');

    const unitPriceFormatted = this.formatMoney(engravingProduct.price / 100);
    const countLabel = engravings.length === 1
      ? '1 surface'
      : `${engravings.length} surfaces (${engravings.length} × ${unitPriceFormatted})`;
    return `
      <div class="cart-item__engravings">
        <strong class="cart-item__engravings-title">Engravings:</strong>
        <ul class="engraving-list">
          ${engravingList}
        </ul>
        <span class="engraving-count-label">${countLabel}</span>
      </div>
    `;
  }

  /**
   * Escape HTML
   * @param {string} text - Text to escape
   * @returns {string} Escaped text
   */
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Format money
   * @param {number} amount - Amount in dollars
   * @returns {string} Formatted money string
   */
  formatMoney(amount) {
    // Use Shopify's money format if available
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(amount * 100, window.money_format || '${{amount}}');
    }
    // Fallback
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }
};
}

// Initialize
if (!window.engravingCartDisplay) {
  window.engravingCartDisplay = new (window.EngravingCartDisplay || class { init() {} })();
}


